module.exports = __webpack_public_path__ + "static/media/pxzs.03a653ea.png";